// Função utilitária para selecionar um número de WhatsApp aleatório
// Esta função retorna aleatoriamente um dos dois números de WhatsApp
// Complexidade: O(1)
// Pode ser importada em qualquer componente que precise de um número de WhatsApp randômico
export function getRandomWhatsappNumber() {
  const numbers = ['47999412720', '48988063917'];
  return numbers[Math.floor(Math.random() * numbers.length)];
} 